import { Box, Typography } from "@mui/joy";
import { ICellRendererParams } from "ag-grid-community";
import { FileDown } from "lucide-react";

import { useReport } from "../../../../hooks/query";
import { Button } from "../../../../shared";

export function GFCAvailableReports(props: ICellRendererParams) {
    const { value, data } = { ...props };
    return (
        <Box py={2}>
            <Typography level="title-md" sx={{ fontWeight: 400 }}>
                {value}
            </Typography>
            <Typography level="body-sm">{data?.Description}, Customer</Typography>
        </Box>
    );
}

export function GFCDownloadReport(props: ICellRendererParams) {
    const { value, data } = { ...props };

    const { useGeneratePreCannedReport } = useReport();
    const generatePreCannedReportSvc = useGeneratePreCannedReport();

    const downloadReport = async () => {
        try {
            const params = {
                ReportType: value,
            };
            await generatePreCannedReportSvc.mutateAsync(params);
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <Box py={2} display={"flex"} pr={0.5} justifyContent={"flex-end"}>
            <Button
                variant={"soft"}
                sx={{ border: "1px solid", borderColor: "divider" }}
                color={"neutral"}
                startDecorator={<FileDown size={16} />}
                onClick={downloadReport}
                loading={generatePreCannedReportSvc.isPending}
                loadingPosition={"start"}
            >
                Download
            </Button>
        </Box>
    );
}
